import { render, staticRenderFns } from "./CommTables.vue?vue&type=template&id=fdeb2906&scoped=true&"
import script from "./CommTables.vue?vue&type=script&lang=js&"
export * from "./CommTables.vue?vue&type=script&lang=js&"
import style0 from "./CommTables.vue?vue&type=style&index=0&id=fdeb2906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeb2906",
  null
  
)

export default component.exports